import { cloneDeep } from "lodash";
import {
    ReportItemsState,
    ReportOverallDataSingleFilter,
    ReportOverallData,
    ReportOverviewData,
    ReportItemStateData,
    ReportSummaryInfo,
    ReportFilterItemsState,
    ReportItemsLoading,
} from "types/Reports";

export const initialReportItemsLoading: ReportItemsLoading = {
    room: true,
    energy: true,
    water: true,
    waterLeakage: true,
    temperature: true,
    humidity: true,
    co2: true,
    pressure: true,
    tvoc: true,
    pm1: true,
    'pm2.5': true,
    pm10: true,
};

export const initialReportItemsState: ReportItemsState = {
    room: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    energy: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    water: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    waterLeakage: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    temperature: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    humidity: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    co2: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    pressure: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    tvoc: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    pm1: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    'pm2.5': {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
    pm10: {
        all: [],
        selectedIds: [],
        appliedIds: [],
    },
};

export const initialReportOverallDataSingleFilter: ReportOverallDataSingleFilter = {
    data: [],
    highestItem: {
        dates: [],
        value: null
    },
    lowestItem: {
        dates: [],
        value: null
    },
    average: null,
    prevAverage: null,
};

export const initialReportOverallData: ReportOverallData = {
    categories: [],
    all: cloneDeep(initialReportOverallDataSingleFilter),
    weekdays: cloneDeep(initialReportOverallDataSingleFilter),
    weekends: cloneDeep(initialReportOverallDataSingleFilter),
};

export const initialReportOverviewData: ReportOverviewData = {
    room: { overallData: cloneDeep(initialReportOverallData), individualData: [] },
    energy: { overallData: cloneDeep(initialReportOverallData), individualData: [] },
    water: { overallData: cloneDeep(initialReportOverallData), individualData: [] },
    waterLeakage: { overallData: cloneDeep(initialReportOverallData), individualData: [] },
};

export const initialReportItemsStateData: ReportItemStateData = {
    room: {
        chartSeries: [],
        prevChartSeries: [],
    },
    energy: {
        chartSeries: [],
        prevChartSeries: [],
    },
    water: {
        chartSeries: [],
        prevChartSeries: [],
    },
    waterLeakage: {
        chartSeries: [],
        prevChartSeries: [],
    },
    temperature: {
        chartSeries: [],
        prevChartSeries: [],
    },
    humidity: {
        chartSeries: [],
        prevChartSeries: [],
    },
    co2: {
        chartSeries: [],
        prevChartSeries: [],
    },
    pressure: {
        chartSeries: [],
        prevChartSeries: [],
    },
    tvoc: {
        chartSeries: [],
        prevChartSeries: [],
    },
    pm1: {
        chartSeries: [],
        prevChartSeries: [],
    },
    'pm2.5': {
        chartSeries: [],
        prevChartSeries: [],
    },
    pm10: {
        chartSeries: [],
        prevChartSeries: [],
    },
};

export const initialSummaryInfoSingleType = {
    total: null,
    previousTotal: null,
    percent: null,
};

export const initialSummaryInfo: ReportSummaryInfo = {
    all: {
        room: {...initialSummaryInfoSingleType},
        energy: {...initialSummaryInfoSingleType},
        water: {...initialSummaryInfoSingleType},
        waterLeakage: { ...initialSummaryInfoSingleType },
    },
    weekdays: {
        room: {...initialSummaryInfoSingleType},
        energy: {...initialSummaryInfoSingleType},
        water: {...initialSummaryInfoSingleType},
        waterLeakage: { ...initialSummaryInfoSingleType },
    },
    weekends: {
        room: {...initialSummaryInfoSingleType},
        energy: {...initialSummaryInfoSingleType},
        water: {...initialSummaryInfoSingleType},
        waterLeakage: { ...initialSummaryInfoSingleType },
    },
};

export const initialReportFilterItemsState: ReportFilterItemsState = {
    room: {
        all: [],
        selected: [],
    },
    energy: {
        all: [],
        selected: [],
    },
    water: {
        all: [],
        selected: [],
    },
    waterLeakage: {
        all: [],
        selected: [],
    },
    temperature: {
        all: [],
        selected: [],
    },
    humidity: {
        all: [],
        selected: [],
    },
    co2: {
        all: [],
        selected: [],
    },
    pressure: {
        all: [],
        selected: [],
    },
    tvoc: {
        all: [],
        selected: [],
    },
    pm1: {
        all: [],
        selected: [],
    },
    'pm2.5': {
        all: [],
        selected: [],
    },
    pm10: {
        all: [],
        selected: [],
    },
};
